import React, { useEffect, useRef } from 'react';
import { useDispatch,useSelector } from 'react-redux';
import { obtEstadCT, obtFechaCCT, obtFechaC911 } from "../features/ctdata/ctSlice.js";
import { inicpag } from '../features/ctdata/pagSlice';
import { useReactToPrint } from 'react-to-print';
import { Button } from "antd";
import CedInic from './CedInic';
import CedInic2020 from './CedInic2020';
import CedInicNE from './CedInicNE';
import CedPree from './CedPree';
import CedPrim from './CedPrim';
import CedPreeCom from './CedPreeCom';
import CedPrimCom from './CedPrimCom';
import CedSec from './CedSec';
import CedSecCom from './CedSecCom';
import CedCam from './CedCam';
import CedUsaer from './CedUsaer';
import CedCapa from './CedCapa';
import CedBach from './CedBach';
import CedSup from './CedSup';

function GenCedEst(props) {
  const dispatch = useDispatch();
  const { estad,loadingestad, loadingfechacct, loadingfechac911 } = useSelector((state) => state.esc);
  const documentTitle = "Estadistica educativa";
  const pageStyle = `
  @page {
    size: letter;
    margin: 20mm;
  }
  @media all {
    .pagebreak {
      display: none;
    }
  }
  @media print {
    @page {
      size: letter;
      margin: 12mm 15mm 6mm 15mm;
    } 
    .pagebreak {
      page-break-after: always;
    }
    .encabezadocedula {
      visibility:visible; 
    }
  }
  `;
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle,
    pageStyle
  });
  const stylebot = {
    margin: 0,
    top: 'auto',
    right: 25,
    bottom: 30,
    left: 'auto',
    position: 'fixed',
    width: '120px'
    //fontSize: 40
  };
  const stylebotapoyos = {
    margin: 0,
    top: 'auto',
    right: 25,
    bottom: 80,
    left: 'auto',
    position: 'fixed',
    width: '120px'
  };
  const ObtenNivel=()=> {
    let cadena=[];
    if (estad.length){
      switch(estad[0].cvetipoedu){
        case "0":
          switch (estad[0].cvetipoct){
            case "10"://Especial
                if (estad[0].cvenivel==="0" && estad[0].cvesubnivel==="0"){
                  cadena.push(<CedUsaer ref={componentRef}/>);
                }
                break;
            case "13"://Superior
                if (estad[0].cvenivel==="0" && estad[0].cvesubnivel==="0"){
                  cadena.push(<CedSup ref={componentRef}/>);
                }
                break;                
            case "18"://Media superior
                if ((estad[0].cvenivel==="0") && (estad[0].cvesubnivel==="0")){
                  cadena.push(<CedBach ref={componentRef}/>);
                }
                break;
            default:
              console.log("Modalidad de educación especial, bachillerato o superior, no identificada");
          }
          break;
        case "1":
          if (estad[0].cvenivel==="1"){
            switch (estad[0].cvesubnivel) {
              case '1':
                if (parseInt(props.ciclo)>2020){cadena.push(<CedInic ref={componentRef}/>);}
                else{cadena.push(<CedInic2020 ref={componentRef}/>);}
                break;
              case '2':
              case '3':
                cadena.push(<CedInicNE ref={componentRef}/>);
                break;
              default:
                console.log("Modalidad de inicial no identificada");
            }            
          } else {
            console.log("Modalidad de educación inicial no identificada");
          }
          break;
        case "2":
          switch (estad[0].cvenivel) {
            case '1':
              switch (estad[0].cvesubnivel) {
                case '1':
                case '3':
                  cadena.push(<CedPree ref={componentRef}/>);
                  break;
                case '2':
                  cadena.push(<CedPreeCom ref={componentRef}/>);
                  break;
                default:
                  console.log("Modalidad de preescolar no identificada");
              }
              break;
            case '2':
              switch (estad[0].cvesubnivel) {
                case '1':
                case '3':
                  cadena.push(<CedPrim ref={componentRef}/>);
                  break;
                case '2':
                  cadena.push(<CedPrimCom ref={componentRef}/>);
                  break;
                default:
                  console.log("Modalidad de primaria no identificada");
              }
              break;
            case '3':
              switch (estad[0].cvesubnivel) {
                case '1':
                case '3':
                case '4':
                  cadena.push(<CedSec ref={componentRef}/>);
                  break;
                case '2':
                  cadena.push(<CedSecCom ref={componentRef}/>);
                  break;
                default:
                  console.log("Modalidad de secundaria no identificada");
              }
              break;
            default:
              console.log("Nivel no identificado");
          }
          break;
        case "3":
          if (estad[0].cvenivel==="1"){
            cadena.push(<CedBach ref={componentRef}/>);
          }else{
            console.log("Modalidad de bachillerato no identificada");
          }
          break;
        case "4":
            if (estad[0].cvenivel==="1"){
              cadena.push(<CedSup ref={componentRef}/>);
            }else{
              console.log("Modalidad de superior no identificada");
            }
          break;
        case "5":
          if (estad[0].cvenivel==="1" && estad[0].cvesubnivel==="1"){
            cadena.push(<CedCapa ref={componentRef}/>);
          } else {
            console.log("Modalidad de capacitación no identificada");
          }
          break;
        case "6":
          if (estad[0].cvenivel==="1" && estad[0].cvesubnivel==="1"){
            cadena.push(<CedCam ref={componentRef}/>);
          } else {
            console.log("Modalidad de educación especial no identificada");
          }
          break;
        default:
          console.log(estad[0].cvect+" ****Tipo educativo no identificado:"+estad[0].cvetipoedu);
      }
      if ((estad[0].cvetipoedu==="0") || (estad[0].cvetipoedu==="1") || (estad[0].cvetipoedu==="2") || (estad[0].cvetipoedu==="3") || (estad[0].cvetipoedu==="4") || (estad[0].cvetipoedu==="5") || (estad[0].cvetipoedu==="6")){
        if (cadena.length){
/*           cadena.push(
            <Button type="primary" size="large" style={stylebotapoyos} onClick={apoyosCt}>
              Apoyos
            </Button>
          ); */
          cadena.push(<Button type="primary" size={'large'} style={stylebot} onClick={handlePrint}>Impresión</Button>)
          dispatch(inicpag());
          return cadena;
        }
      }
    } else {
        //return <div id="capobtnivel" style={{ top: "10px", left: "100px" }}><Spin/></div>
        return <div><h2>Cédula no disponible</h2></div>
        //<Aviso/>
    }
  }
  const apoyosCt = () => {
    window.location.href = `https://estadisticas.setab.gob.mx/cct/apoyos/ced/${props.cvect}`;
    /* window.open(`https://estadisticas.setab.gob.mx/cct/apoyos/ced/${props.cvect}`, '_blank'); */
/*     window.open(
  `https://estadisticas.setab.gob.mx/cct/apoyos/ced/${props.cvect}`,
  '_blank',
  'noopener'
); */
  };

  async function cargarDatos() {
    dispatch(obtEstadCT({cveced:props.cvect,ciclocifras:props.ciclo}));
    dispatch(obtFechaCCT({"datos":"cct"}));
    dispatch(obtFechaC911({"datos":"c911","ciclo":props.ciclo}));
  }

  useEffect(() => {
    cargarDatos();
     // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  return loadingestad==="estad loaded" && loadingfechacct==="fechacct loaded" && loadingfechac911==="fechac911 loaded"?<ObtenNivel/>:[]
};

export default GenCedEst;